import { OnAnimationFrame } from "../../../library-js/animation/OnAnimationFrame";
import { DateHelper } from "../../../library-js/date/DateHelper";
import { DateMath } from "../../../library-js/date/DateMath";
import { AttributeValue } from "../../../library-js/dom-tools/AttributeValue";
import { ClassFlag } from "../../../library-js/dom-tools/ClassFlag";
import { ElementAttribute } from "../../../library-js/dom-tools/ElementAttribute";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { OnClick } from "../../../library-js/dom-tools/EventListeners";
import { HTMLEditor } from "../../../library-js/dom-tools/HTMLEditor";
import { TemplatesManager } from "../../../library-js/templates/TemplatesManager";
import { PersonalData } from "../../../library/ts/vanilla/ecommerce/PersonalData";
import { Rokojori } from "../../js/Rokojori";
import { PaypalCheckout } from "./PaypalCheckout";
import { PayPalValidator } from "./PayPalValidator";

export class BuyNow
{
  static type      = new ClassFlag( "buy-now" );
  static lock      = new ElementAttribute( "lock-data" );
  static container = new ElementAttribute( "container" ); 

  static fullName = new AttributeValue( ElementAttribute.dataName, "Full Name" );
  static email = new AttributeValue( ElementAttribute.dataName, "Email" );
  
  static streetNumber = new AttributeValue( ElementAttribute.dataName, "Street Number" );
  static zipCodeCity  = new AttributeValue( ElementAttribute.dataName, "ZipCode City" );
  static country      = new AttributeValue( ElementAttribute.dataName, "Country" );
 
  static validator:PayPalValidator;
  static initialized = false;
  static pdLocked =false;
  static pdUpdateTime = new Date().getTime();
  static savingDurationMS = 5000;
  static pdString:string = null; 
  static onCheckout = false;

  static initialize( everyFrame:OnAnimationFrame )
  { 
    if ( BuyNow.initialized )
    {
      return;
    }
    
    everyFrame.addListener(
      ()=>
      {
        if ( BuyNow.pdLocked || ! BuyNow.onCheckout )
        {
          //console.log( "Locked", BuyNow.pdLocked, "On Check", BuyNow.onCheckout );
          return;
        }  

        let now = new Date().getTime();
        let elapsed = now - BuyNow.pdUpdateTime;

        if ( elapsed < this.savingDurationMS )
        {
          return;
        }

        let cart = Rokojori.$.assetManagerServer.assetsCart;

        if ( ! cart.personalData )
        {
          cart.personalData = new PersonalData();
        }

        cart.personalData.email = BuyNow.getPD( BuyNow.email );
        cart.personalData.fullName = BuyNow.getPD( BuyNow.fullName );
        
        cart.personalData.streetNumber = BuyNow.getPD( BuyNow.streetNumber );
        cart.personalData.zipCodeCity = BuyNow.getPD( BuyNow.zipCodeCity );
        cart.personalData.country = BuyNow.getPD( BuyNow.country );

        let pdString = JSON.stringify( cart.personalData );

        if ( pdString === BuyNow.pdString )
        {
         // console.log( "Same data" );
          return;
        }

        BuyNow.pdString = pdString;
        BuyNow.pdUpdateTime = now;

        console.log( "Saving PD" ); 
        cart.savePersonalData();
      }
    );

    this.initialized = true;
  }

  static applyOnDocument( everyFrame:OnAnimationFrame,  templatesManager:TemplatesManager )
  {
    BuyNow.onCheckout = false;
    BuyNow.initialize( everyFrame );
    
    BuyNow.type.forEachInDoc( e => this.applyOnElement( e, templatesManager ) );
  }

  static setPD( attValue:AttributeValue, value:string )
  {
    value = value || "";
    let inputFieldContainer = attValue.queryDoc();

    if ( ! inputFieldContainer )
    {
      let selector = attValue.selector;
      console.error( "PD Field not found:", selector, ">>", value, attValue );
      return;
    }

    let inputField = ElementType.input.query( inputFieldContainer );

    if ( ! inputField )
    {
      console.error( "PD Field input not found:", inputFieldContainer, attValue, value );
      return;
    }

    inputField.value = value;
  }

  static getPD( attValue:AttributeValue )
  {
    let inputFieldContainer = attValue.queryDoc();
    let inputField = ElementType.input.query( inputFieldContainer );
    return inputField.value;
  }

  static async applyOnElement( e:Element, templatesManager:TemplatesManager )
  {
    BuyNow.validator = new PayPalValidator();

    BuyNow.onCheckout = true;

    let cart = Rokojori.$.assetManagerServer.assetsCart;

    BuyNow.pdLocked = true;
    await cart.sync();

    let pData = cart.personalData || ( new PersonalData() );

    console.log( "PD DATA:", pData );
    BuyNow.setPD( BuyNow.email, pData.email );
    BuyNow.setPD( BuyNow.fullName, pData.fullName );

    BuyNow.setPD( BuyNow.streetNumber, pData.streetNumber );
    BuyNow.setPD( BuyNow.zipCodeCity, pData.zipCodeCity );
    BuyNow.setPD( BuyNow.country, pData.country );

    BuyNow.pdLocked = false;

    OnClick.add( e as HTMLElement, 
      async ()=>
      { 

        BuyNow.pdLocked = true;

        let cart = Rokojori.$.assetManagerServer.assetsCart;

        cart.personalData = new PersonalData();
        cart.personalData.email = BuyNow.getPD( BuyNow.email );
        cart.personalData.fullName = BuyNow.getPD( BuyNow.fullName );
        
        cart.personalData.streetNumber = BuyNow.getPD( BuyNow.streetNumber );
        cart.personalData.zipCodeCity = BuyNow.getPD( BuyNow.zipCodeCity );
        cart.personalData.country = BuyNow.getPD( BuyNow.country );

        await cart.savePersonalData();


        let container = document.querySelector( BuyNow.container.from( e ) );

        container.innerHTML = "";
        
        let paypalCheckout = templatesManager.createTemplate( PaypalCheckout.type.selector );
        
        container.appendChild( paypalCheckout );

        let lock = BuyNow.lock.queryDoc() as HTMLElement;

        lock.style.pointerEvents = "none";
        lock.style.opacity = "0.75";

        BuyNow.lock.to( lock, "locked" );
        

        HTMLEditor.remove( e );
        PaypalCheckout.applyOnDocument();

      } 
    );
  }
}